import React from "react";
import useNewsData from "../../../hooks/useNewsData";
import "./CompanyNews.scss";
import NewsCard from "./NewsCard/NewsCard";

const CompanyNews = () => {
  const [newsData, setNewsData] = useNewsData();
  return (
    <>
      <div className="company_news">
        <div className="container">
          <div className="row">
            {newsData.map((news) => (
              <NewsCard news={news} key={news.title}></NewsCard>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyNews;
